/** @jsxImportSource @emotion/react */
import { useMemo } from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { type FeatureBannerProps } from './FeatureBanner.types'
import {
  featureBannerWrapper,
  featureBannerPill,
  featureBannerTypography,
  featureBannerLink,
} from './FeatureBanner.styles'

export const FeatureBanner = ({ featureName }: FeatureBannerProps) => {
  const theme = useTheme()

  const formattedFeatureName = useMemo(() => {
    return featureName.split(/(?=[A-Z])/).join(' ')
  }, [featureName])

  return (
    <Box css={featureBannerWrapper({ theme })}>
      <Box css={featureBannerPill()}>BETA</Box>
      <Typography css={featureBannerTypography()}>
        <span style={{ textTransform: 'capitalize' }}>{formattedFeatureName}</span> is in Beta.
        Share your thoughts on the{' '}
        <a
          css={featureBannerLink()}
          href="https://forum.resilience-explorer.com"
          target="_blank"
          rel="noreferrer"
        >
          Forum
        </a>
      </Typography>
    </Box>
  )
}
